import { graphqlOperation, API } from 'aws-amplify';
import { Locale } from 'vue-i18n';
import { GetProductAuthQuery } from '@/appsync/graphql/authQuery';
import { MenuNameType, DescriptionNameType } from '@/appsync/graphql/menu';
import {
  MenuIcon,
  Product,
  ProductAdditionalQueryMap,
  GetTenantLandscapeAllInfoQuery,
} from '@/types/type';

export const graphqlQuery = async <T extends {}, R extends {}>(
  query: string,
  variables?: R
): Promise<T | null> => {
  const result = await API.graphql(graphqlOperation(query, variables));
  return 'data' in result && result.data ? (result.data as T) : null;
};

export const getNameByLang = (
  names: MenuNameType[] | null,
  language: Locale
): string => {
  const languageSet = names
    ? names.find(val => val.language === language)
    : null;
  return languageSet && languageSet.name ? languageSet.name : '';
};

export const getDescriptionByLang = (
  names: DescriptionNameType[] | null,
  language: Locale
): string => {
  const languageSet = names
    ? names.find(val => val.language === language)
    : null;
  return languageSet && languageSet.description ? languageSet.description : '';
};

export const getIcon = (menuIconFont: string | null): MenuIcon => {
  switch (menuIconFont) {
    case 'wap-icon-pencil':
      return 'mdi-pencil';
    case 'wap-icon-cog':
      return 'mdi-cog';
    case 'wap-icon-file-memo':
      return 'mdi-note-text';
    default:
      return 'mdi-briefcase';
  }
};

export const addParameterToUrl = (
  url: string,
  product: Product,
  productAdditionalQueryMap?: ProductAdditionalQueryMap
): string => {
  if (productAdditionalQueryMap) {
    const query = productAdditionalQueryMap[product];
    if (query) {
      return !new URL(url).search
        ? `${url}?${query.slice(1)}`
        : `${url}${query}`;
    }
  }
  return url;
};

export const productAdditionalQueryMap = (
  result: GetTenantLandscapeAllInfoQuery | GetProductAuthQuery | null
): ProductAdditionalQueryMap => {
  const resultMap: ProductAdditionalQueryMap = {};
  if (result && result.authQueryCJK) {
    resultMap[result.authQueryCJK.product] =
      result.authQueryCJK.additionalQuery;
  }
  if (result && result.authQueryCWS) {
    resultMap[result.authQueryCWS.product] =
      result.authQueryCWS.additionalQuery;
  }
  if (result && result.authQueryCSR) {
    resultMap[result.authQueryCSR.product] =
      result.authQueryCSR.additionalQuery;
  }
  if (result && result.authQueryCTM) {
    resultMap[result.authQueryCTM.product] =
      result.authQueryCTM.additionalQuery;
  }
  return resultMap;
};
